module.exports = ":host {\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/grid-container/grid-container.style.scss
// module id = 863
// module chunks = 2